import { Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { authGuardFn } from '@core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    children: [
      {
        path: '',
        redirectTo: 'main',
        pathMatch: 'full',
      },

      {
        path: 'main',
        loadChildren: () =>
          import('../app/layout/main/main.routing.module').then(
            (m) => m.MainRoutingModule
          ),
        canActivate: [authGuardFn],
      },
      {
        path: 'login',
        loadComponent: () =>
          import('../app/features/login/login.component').then(
            (m) => m.LoginComponent
          ),
      },
    ],
  },
];
